import { useEffect, useState } from "react";
import {
  Button,
  Card,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { api } from "../api";
import { PageHeader } from "../components/PageHeader";
import { StatusChip } from "../components/StatusChip";
export function AlertsPage() {
  const [rows, setRows] = useState<any[]>([]);
  const load = () =>
    api<{ alerts: any[] }>("/admin/alerts?status=").then((r) =>
      setRows(r.alerts),
    );
  useEffect(() => {
    void load();
  }, []);
  return (
    <>
      <PageHeader
        title="Alerts"
        subtitle="Quota, OCR and webhook conditions requiring attention."
      />
      <Card>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Created</TableCell>
              <TableCell>Severity</TableCell>
              <TableCell>Type</TableCell>
              <TableCell>Message</TableCell>
              <TableCell>Status</TableCell>
              <TableCell />
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((r) => (
              <TableRow key={r.id}>
                <TableCell>{new Date(r.created_at).toLocaleString()}</TableCell>
                <TableCell>
                  <StatusChip value={r.severity} />
                </TableCell>
                <TableCell>{r.type}</TableCell>
                <TableCell>{r.message}</TableCell>
                <TableCell>
                  <StatusChip value={r.status} />
                </TableCell>
                <TableCell>
                  {r.status === "OPEN" && (
                    <Button
                      onClick={async () => {
                        await api(`/admin/alerts/${r.id}/acknowledge`, {
                          method: "POST",
                        });
                        void load();
                      }}
                    >
                      Acknowledge
                    </Button>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
    </>
  );
}
